<template lang="pug">
  main
    NavBarEstaciones
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns.section-title.has-text-dark
          .column.is-half.is-offset-one-quarter.has-text-centered
            h1.title  {{ estacionStr }} &nbsp
        .columns.has-text-centered.is-centered.is-multiline.has-text-dark
          .column.is-3(v-show="verGia")
            .card
              .card-content
                span.icon.is-large.is-size-6
                  span.fa-stack.fa-lg
                    i.fas.fa-circle.fa-stack-2x
                    i.fas.fa-tag.fa-stack-1x.fa-inverse
                p.has-text-weight-medium.is-size-5 Sistemas e Instrumentación
                br
                router-link.a.button.is-dark.is-rounded.is-size-6(to="/HomeGia") Entrar
          .column.is-3(v-show="verReportes")
            .card
              .card-content
                span.icon.is-large.is-size-6
                  span.fa-stack.fa-lg
                    i.fas.fa-circle.fa-stack-2x
                    i.fas.fa-file-signature.fa-stack-1x.fa-inverse
                p.has-text-weight-medium.is-size-5 Reportes
                br
                a.button.is-dark.is-rounded(@click="irReportes") Entrar
          .column.is-3(v-show="verCombustibles")
            .card
              .card-content
                span.icon.is-large.is-size-6
                  span.fa-stack.fa-lg
                    i.fas.fa-circle.fa-stack-2x
                    i.fas.fa-car.fa-stack-1x.fa-inverse
                p.has-text-weight-medium.is-size-5 Transportes
                br
                router-link.a.button.is-dark.is-rounded.is-size-6(to="/Transportes") Entrar
          .column.is-3(v-show="verResponsivas")
            .card
              .card-content
                span.icon.is-large.is-size-6
                  span.fa-stack.fa-lg
                    i.fas.fa-circle.fa-stack-2x
                    i.fas.fa-file-signature.fa-stack-1x.fa-inverse
                p.has-text-weight-medium.is-size-5 Responsivas
                br
                router-link.a.button.is-dark.is-rounded.is-size-6(to="/Responsivas") Entrar
          .column.is-3
            .card
              .card-content
                span.icon.is-large.is-size-6
                  span.fa-stack.fa-lg
                    i.fas.fa-circle.fa-stack-2x
                    i.fas.fa-laptop-medical.fa-stack-1x.fa-inverse
                p.has-text-weight-medium.is-size-5 Soporte
                br
                router-link.a.button.is-dark.is-rounded.is-size-6(to="/Soporte") Entrar
          .column.is-3(v-show="verMonitoreo")
            .card
              .card-content
                span.icon.is-large.is-size-6
                  span.fa-stack.fa-lg
                    i.fas.fa-circle.fa-stack-2x
                    i.fas.fa-industry.fa-stack-1x.fa-inverse
                p.has-text-weight-medium.is-size-5 Monitoreo
                br
                a.button.is-dark.is-rounded(@click="irMonitoreo") Entrar
          .column.is-3(v-show="verInventario")
            .card
              .card-content
                span.icon.is-large.is-size-6
                  span.fa-stack.fa-lg
                    i.fas.fa-circle.fa-stack-2x
                    i.fas.fa-cart-arrow-down.fa-stack-1x.fa-inverse
                p.has-text-weight-medium.is-size-5 Inventarios de Equipos Asignados
                br
                router-link.a.button.is-dark.is-rounded.is-size-6(:to="isAlmacenistaCede ? '/Inventario/Administracion':'/Inventario/Asignaciones'") Entrar
          .column.is-3(v-show="isAlmacenistaCede")
            .card
              .card-content
                span.icon.is-large.is-size-6
                  span.fa-stack.fa-lg
                    i.fas.fa-circle.fa-stack-2x
                    i.fas.fa-shopping-cart.fa-stack-1x.fa-inverse
                p.has-text-weight-medium.is-size-5 Almacén
                br
                router-link.a.button.is-dark.is-rounded.is-size-6(to="/Inventario/Almacen") Entrar
</template>

<script>
import Loader from '@/components/shared/Loader.vue'
import NavBarEstaciones from '@/components/estaciones_Componentes/NavBarEstaciones.vue'
import NotificacionConst from '@/components/shared/NotificacionConst.vue'
import ticketServices from "@/services/soporte/tickets"
import { mapState } from 'vuex'
import InventarioServices from '../services/inventario/inventario'

export default {
  name: 'HomeEstaciones',
  components: { Loader, NavBarEstaciones, NotificacionConst },
  data () {
    return {
      isLoading: false,
      estacionStr: '',
      verInventario: false,
      verGia: false,
      verBascula: false,
      verCombustibles: false,
      verResponsivas: false,
      verMonitoreo: false,
      verReportes: false,
      textosNotificaciones: [
        {titulo: 'En contrucción', fecha: '22/09/2020', texto: 'Act.', tipo: 'c'},
        {titulo: 'En proyecto', fecha: '22/09/2020', texto: 'Act.', tipo: 'pr'},
        {titulo: 'En pruebas', fecha: '22/09/2020', texto: 'Act.', tipo: 'p'}
      ],
      isAlmacenistaCede: false,
      almacenes: [],
    }
  },
  methods: {
    iniciarComponente () {
      this.obtenerAlmacenes()
      this.estacionStr = `Aplicaciones para ${this.estacionSel}`
    },
    obtenerAlmacenes() {
      InventarioServices.getAlmacenesConsumibles('c')
          .then( data => {
            this.almacenes = data.map(this.convertirAlmacenes)
            this.isAlmacenistaCede = this.almacenes.some( a => a.almacenista === this.userLogin.id)
            this.obtenerUser()
          })
          .catch((e) => {
            this.isLoading = false
            this.displayToast('bubble', `Error: ${e.message}`,'ban', 'OK')
          })
      
    },
    convertirAlmacenes (ofi) {
        return {
          ...ofi,
          id: parseInt(ofi.id),
          id_ubicacion: parseInt(ofi.id_ubicacion),
          id_oficina: parseInt(ofi.id_oficina),
          inventario: parseInt(ofi.inventario) == 1 ? true : false,
        }
      },
    obtenerUser() {
      if (Object.keys(this.userLogin).length === 0) {
        this.$router.push('/')
      } else {
        if (this.permisos) {
          this.verMonitoreo = this.permisos.monitoreo != 2
          this.verCombustibles = this.permisos.combustibles != 2
          this.verInventario = this.permisos.inventarios != 2
          this.verReportes = this.permisos.reportes != 2
          this.verResponsivas = this.permisos.responsivas != 2
          
          if (this.userLogin.departamento == 3 || this.userLogin.departamento == 6) {
            this.verGIA = true
          }
          if (this.verInventario) {
            if (this.permisos.inventarios == 4) {
              console.log('Here')
              this.isAlmacenistaCede = true
              this.$store.commit('selectAlmacen', 'c')
            }
          }
        }

        if (this.userLogin.departamento === 1 || this.userLogin.departamento === 3 || this.userLogin.departamento === 6) {
          this.checkTickets()
        }
      }
    },
    irReportes () {
      location.href = '/reportesApp/home.html'
    },
    irMonitoreo () {
      console.log('Ir a monitorear' + this.estacionSel)
      this.$router.push('/Monitor')
    },
    checkSolicitudesPendientes () {
      switch (this.userLogin.categoria) {
        case 0:
          console.log('gerentes')
          if (this.userLogin.ubicacion === 'LPG_DUCTO') {
            console.log('DUCTO')
            InventarioServices.getSolicitudes_ducto()
              .then( res => {
                let sol_depto = res.filter( sol => sol.estado === '2')
                  if ( sol_depto.length > 0 ) {
                    let arrayS_1  = sol_depto.filter( sol => sol.departamento !== '1')
                    let arrayS_3  = arrayS_1.filter( sol => sol.departamento !== '3')
                    let arrayS_6  = arrayS_3.filter( sol => sol.departamento !== '6')
                    this.displayToast(arrayS_6.length)
                  }
                  this.checkFirmaRequisiciones()
              })
          } else {
            InventarioServices.getSolicitudes_ubicacion(this.userLogin.ubicacion, 'ALL')
            .then( res => {
              let sol_depto = res.filter( sol => sol.estado === '1')
                if ( sol_depto.length > 0 ) {
                  let arrayS_1  = sol_depto.filter( sol => sol.departamento !== '1')
                  let arrayS_3  = arrayS_1.filter( sol => sol.departamento !== '3')
                  let arrayS_6  = arrayS_3.filter( sol => sol.departamento !== '6')
                  this.displayToast(arrayS_6.length)
                }
                this.checkFirmaRequisiciones()
            })
          }
          break
        case 2:
          console.log('jefes de area y estaciones de trabajo')
          
          if (this.userLogin.departamento === 1 || this.userLogin.departamento === 3) {
            console.log('sistemas o Intrumentos')
            InventarioServices.getSolicitudes_area(this.userLogin.departamento, 'ALL')
              .then( res => {
                let sol_depto = res.filter( sol => parseInt(sol.estado) == 3)
                  if ( sol_depto.length > 0 ) {
                    this.displayToast(sol_depto.length)
                  }
                  this.checkFirmaRequisiciones()
              })
          } else {
            console.log('No es sistemas ni Intrumentos')
            InventarioServices.getSolicitudes_ubicacion(this.userLogin.ubicacion, 'ALL')
              .then( res => {
                console.log(res)
                let sol_depto = res.filter( sol => sol.estado === '1')
                  if ( sol_depto.length > 0 ) {
                    let arrayS_1  = sol_depto.filter( sol => sol.departamento !== '1')
                    let arrayS_3  = arrayS_1.filter( sol => sol.departamento !== '3')
                    let arrayS_6  = arrayS_3.filter( sol => sol.departamento !== '6')
                    if ( arrayS_6.length > 0 ) {
                      this.displayToast(arrayS_6.length)
                    }
                  }
                  this.checkFirmaRequisiciones()
              })
          }
          break
        default:
        break
      }
      
    },
    checkFirmaRequisiciones () {
      switch (this.userLogin.categoria) {
        case 0:
          console.log('gerentes')
          if (this.userLogin.ubicacion === 'ALL') {
            console.log('DUCTO')
            InventarioServices.getRequisiciones_Ubicaciones('CORP', 0)
              .then( res => {
                console.log(res)
                let pendientes = res[0].pendientes
                if ( pendientes > 0) {
                  let strPend = pendientes == 1? 'Requisición Pendiente' : 'Requisiciones Pendientes'
                  let mensaje = `${pendientes} ${strPend}`
                  this.displayToast(mensaje,'done','Ir a Combustible', '/Requisciones')
                }
              })
          } else if (this.userLogin.cargo === '002') {
            console.log('cargo 002')
            InventarioServices.getRequisiciones_Ubicaciones('ALL', 2)
              .then( res => {
                console.log(res)
                let pendientes = res[0].pendientes
                if ( pendientes > 0) {
                  let strPend = pendientes == 1? 'Requisición Pendiente' : 'Requisiciones Pendientes'
                  let mensaje = `${pendientes} ${strPend}`
                  this.displayToast(mensaje,'done','Ir a Combustible', '/Requisciones')
                }
              })
          } else {
            console.log('Demás Gerentes')
            InventarioServices.getRequisiciones_Ubicaciones(this.userLogin.ubicacion, 0)
              .then( res => {
                console.log(res)
                let pendientes = res[0].pendientes
                if ( pendientes > 0) {
                  let strPend = pendientes == 1? 'Requisición Pendiente' : 'Requisiciones Pendientes'
                  let mensaje = `${pendientes} ${strPend}`
                  this.displayToast(mensaje,'done','Ir a Combustible', '/Requisciones')
                }
              })
          }
          break
        case 2:
          console.log('jefes de area')
          
          if (this.userLogin.departamento === 1 || this.userLogin.departamento === 3) {
            InventarioServices.getRequisiciones_Area(this.userLogin.departamento, 1)
              .then( res => {
                console.log(res)
                let pendientes = res[0].pendientes
                if ( pendientes > 0) {
                  let strPend = pendientes == 1? 'Requisición Pendiente' : 'Requisiciones Pendientes'
                  let mensaje = `${pendientes} ${strPend}`
                  this.displayToast(mensaje,'done','Ir a Combustible', '/Requisciones')
                }
              })
          } else {
            console.log('No es sistemas ni Intrumentos')
          }
          break
        default:
        break
      }
    },
    previewfileCotizacion() {
      let file = this.$refs.myTicket.files
      this.fileCotizacion = file[0]
      console.log(this.fileCotizacion)
    },
    displayToast(message, icon, actionText, destiny) {
      let toast = this.$toasted.show(message, { 
        theme: "toasted-primary", 
        position: "bottom-right", 
        duration : 3000,
        iconPack: 'fontawesome',
        icon: icon,
        action : {
          text : actionText,
          onClick : (e, toastObject) => {
            console.log(destiny)
            this.$router.push(destiny)
            toastObject.goAway(0)
          }
        },
      })
    },
    checkTickets() {
      switch (parseInt(this.userLogin.categoria)) {
        case 0:
          ticketServices.searchAll()
            .then((data) => {
              console.log(data)
              let ticketsPend = data.filter((tick) => parseInt(tick.estado) >= 3).length
              console.log(ticketsPend)
              this.sendNotification_tickets(ticketsPend)
            })
            .catch((e)=> {
              this.displayToast(e.message,'ban','Ok','')
            })
          break
        case 2:
          ticketServices.searchTicket_area(this.userLogin.departamento)
            .then((data) => {
              console.log(data)
              let ticketsPend = data.filter((tick) => parseInt(tick.estado) == 1 && parseInt(tick.compra) == 1).length
              console.log(ticketsPend)
              this.sendNotification_tickets(ticketsPend)
            })
            .catch((e)=> {
              this.displayToast(e.message,'ban','Ok','')
            })
          break
        case 3:
          ticketServices.searchTicket_user(this.userLogin.id, 'a')
            .then((data) => {
              console.log(data)
              let ticketsPend = data.filter((tick) => parseInt(tick.estado) < 1).length
              console.log(ticketsPend)
              this.sendNotification_tickets(ticketsPend)

            })
            .catch((e)=> {
              this.displayToast(e.message,'ban','Ok','')
            })
          break
      
        default:
          break
      }
    },
    sendNotification_tickets(ticketsPend) {
      if (ticketsPend > 0) {
        let textToast = ''
        if (ticketsPend == 1) {
          textToast = `${this.userLogin.nombre} tiene ${ticketsPend} ticket pendiente.`
        } else {
          textToast = `${this.userLogin.nombre} tiene ${ticketsPend} tickets pendientes.`
        }
        this.displayToast(textToast,'done','Ir a Soporte','/Soporte')
      }
    }
  },
  computed: {
    ...mapState(['logueado', 'userLogin', 'estacionSel', 'permisos'])
  },
  created () {
    this.iniciarComponente()
  },
}
</script>

<style lang="css" scoped>

  .image {
    display: inline-block;
  }
  .card:hover {
    transform: translateY(-5px) scale(1.005) translateZ(0);
    box-shadow: 0 24px 36px rgba(0,0,0,0.11), 0 14px 16px rgba(0,0,0,0.11);
  }
  .section-title {
    margin-top: 1rem;
    margin-bottom: 2rem;
  }

  .card {
    color: #54545c;
  }

</style>


// WEBPACK FOOTER //
// src/components/HomeEstaciones.vue